import { createMachine } from "xstate";
import PolicyWizardState from "./state";
import PolicyWizardConfig from "./config";

export const PolicyWizardMachine = createMachine(PolicyWizardState, PolicyWizardConfig);
